<div class="grid">
  <div class="no-mobile grid__col-6 account__photo"></div>
  <div class="grid__col-auto center-text grid--align-self-center">
    <a href="/" class="ib rel guts-m-b-1" data-dgat="resetPassword-899">
      <img
        [src]="degreedGlassesLogo"
        static="true"
        alt="Degreed"
        width="56"
        height="36"
        role="img"
      />
    </a>
    <h1
      class="serif color-ebony account__title rel guts-p-b-2 guts-m-b-3 separator separator-center"
      [textContent]="i18n.AccountController_ResetPassword"
    ></h1>
    <div
      class="account__message par"
      aria-live="polite"
      *ngIf="!!specialInstructions"
      [innerHTML]="specialInstructions"
    ></div>
    <div
      class="account__message account__message--error par"
      aria-live="polite"
      *ngIf="!!error"
      [innerHTML]="error"
    ></div>
    <fieldset class="account__wrapper left-text" *ngIf="!passwordChanged">
      <form
        role="form"
        [formGroup]="form"
        class="form-wrap"
        (ngSubmit)="submit()"
      >
        <df-form-root
          [form]="form"
          [options]="options"
          [model]="model"
          [fields]="fields"
        >
        </df-form-root>
        <div class="guts-p-v-1 rel">
          <button
            type="submit"
            df-button
            dfButtonType="primary"
            class="full-width"
            data-dgat="reset-password-348"
          >
            <df-spinner-button [isSpinning]="isSaving">
              <span [textContent]="i18n.AccountController_Continue"></span>
            </df-spinner-button>
          </button>
        </div>
      </form>
    </fieldset>
  </div>
</div>
